module.exports = __webpack_public_path__ + "d3ac8f67dda82489c5e6e7a4dcd2dd5b.svg";